/**
 * Which rave is open on this page, for chrome that sits ABOVE it.
 *
 * The shell (and its footer) is mounted above `EditionProvider`, so it cannot
 * `useEdition()`. The provider announces itself here instead; the version
 * matrix reads it to show the rave's content version and its offline sync.
 */
import { useSyncExternalStore } from 'react';

export interface CurrentRave { editionId: string; name: string }

let current: CurrentRave | null = null;
const listeners = new Set<() => void>();

export function setCurrentRave(rave: CurrentRave | null): void {
  if (current?.editionId === rave?.editionId && current?.name === rave?.name) return;
  current = rave;
  for (const l of listeners) l();
}

export function useCurrentRave(): CurrentRave | null {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => current,
  );
}
